export default __webpack_public_path__ + "static/media/instagram.7c97f0d7.svg";